module.exports = __webpack_public_path__ + "5f84c5900b34eae52df8d892b12229ea.png";